import React from 'react';
import { Profile } from './Profile';
import { SocialIcon } from './SocialIcon';
import { Footer } from './Footer';

function App() {
	return (
		<>
			<Profile />
			<SocialIcon />
			<Footer />
		</>
	);
}

export default App;
